<template>
  <div class="page-content">
    <MariChatBanner />
    <div class="row report-wrapper">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <div class="row position-relative mb-3">
              <div class="col-md-12 report-header">
                <h5>Analytics overview in</h5>
                <el-date-picker
                  v-model="filter.date_range"
                  type="daterange"
                  size="small"
                  :picker-options="date_picker_options"
                  @change="dateCheck"
                  range-separator="To"
                  start-placeholder="Start date"
                  end-placeholder="End date">
                </el-date-picker>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-md-3 text-center">
                <div class="card">
                  <div class="card-body" v-loading="loading.all">
                    <h6 class="mb-3">Chat</h6>
                    <span class="big-icon"><i class="mdi mdi-email mdi-48px"></i></span>
                    <p class="mt-3">
                      <el-tooltip content="Inbound" placement="top" popper-class="fit-tooltip">
                        <i class="mdi mdi-call-received" style="cursor: pointer;"></i>
                      </el-tooltip >
                      {{ message_count.inbound }}
                      <span class="spacer"></span>
                      <el-tooltip content="Outbound" placement="top" popper-class="fit-tooltip">
                        <i class="mdi mdi-call-made" style="cursor: pointer;"></i>
                      </el-tooltip >
                      {{ message_count.outbond }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-md-3 text-center">
                <div class="card">
                  <div class="card-body" v-loading="loading.all">
                    <h6 class="mb-3">Status Conversation</h6>
                    <span class="big-icon"><i class="mdi mdi-forum mdi-48px"></i></span>
                    <div>
                      <p class="mt-3">
                        <el-tooltip content="Open" placement="top" popper-class="fit-tooltip">
                          <i class="mdi mdi-email-open" style="cursor: pointer;"></i>
                        </el-tooltip>
                        {{ conversation_status_count.open }}
                        <span class="spacer"></span>
                        <el-tooltip content="Handling" placement="top" popper-class="fit-tooltip">
                          <i class="mdi mdi-handshake" style="cursor: pointer;"></i>
                        </el-tooltip>
                        {{ conversation_status_count.handling }}
                        <span class="spacer"></span>
                        <el-tooltip content="Resolved" placement="top" popper-class="fit-tooltip">
                          <i class="mdi mdi-check-bold" style="cursor: pointer;"></i>
                        </el-tooltip>
                        {{ conversation_status_count.resolved }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-3 text-center">
                <div class="card">
                  <div class="card-body" v-loading="loading.all">
                    <h6 class="mb-3">Call</h6>
                    <span class="big-icon"><i class="mdi mdi-phone mdi-48px"></i></span>
                    <p class="mt-3">
                      <el-tooltip content="Incoming" placement="top" popper-class="fit-tooltip">
                        <i class="mdi mdi-call-received" style="cursor: pointer;"></i>
                      </el-tooltip>
                      {{ calls_count.inbound }}
                      <span class="spacer"></span>
                      <el-tooltip content="Outgoing" placement="top" popper-class="fit-tooltip">
                        <i class="mdi mdi-call-made" style="cursor: pointer;"></i>
                      </el-tooltip>
                      {{ calls_count.outbond }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-md-3 text-center">
                <div class="card">
                  <div class="card-body" v-loading="loading.all">
                    <h6 class="mb-3">Leads</h6>
                    <span class="big-icon"><i class="mdi mdi-developer-board mdi-48px"></i></span>
                    <p class="mt-3">
                      <el-tooltip content="Open" placement="top" popper-class="fit-tooltip">
                        <i class="mdi mdi-check-bold" style="cursor: pointer;"></i>
                      </el-tooltip>
                      {{ leads_count.open }}
                      <span class="spacer"></span>
                      <el-tooltip content="Close" placement="top" popper-class="fit-tooltip">
                        <i class="mdi mdi-close" style="cursor: pointer;"></i>
                      </el-tooltip>
                      {{ leads_count.close }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-md-3 text-center">
                <div class="card" style="height: 135px;">
                  <div class="card-body" v-loading="loading.all">
                    <div class="d-flex">
                      <span class="big-icon mr-3 d-flex align-items-center"><i class="mdi mdi-message-processing mdi-48px"></i></span>
                      <div class="d-flex flex-column justify-content-start text-left">
                        <h6 class="mb-2">Average First Time<br>Response</h6>
                        <span>{{ formatAvgTime((conversation_count.avg_first_time_response)) }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-3 text-center">
                <div class="card" style="height: 135px;">
                  <div class="card-body" v-loading="loading.all">
                    <div class="d-flex">
                      <span class="big-icon mr-3 d-flex align-items-center"><i class="mdi mdi-message-processing mdi-48px"></i></span>
                      <div class="d-flex flex-column justify-content-start text-left">
                        <h6 class="mb-2">Average Resolved<br>Duration</h6>
                        <span>{{ formatAvgTime((conversation_count.avg_resolved_time)) }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-3 text-center">
                <div class="card" style="height: 135px;">
                  <div class="card-body" v-loading="loading.all">
                    <div class="d-flex">
                      <span class="big-icon mr-3 d-flex align-items-center"><i class="mdi mdi-phone mdi-48px"></i></span>
                      <div class="d-flex flex-column justify-content-start text-left">
                        <h6 class="mb-2">Average Call<br>Duration</h6>
                        <span>{{ (formatAvgTime((call_count.avg_all))) }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-3 text-center">
                <div class="card" style="height: 135px;">
                  <div class="card-body" v-loading="loading.all">
                    <div class="d-flex">
                      <span class="big-icon mr-3 d-flex align-items-center"><i class="mdi mdi-phone mdi-48px"></i></span>
                      <div class="d-flex flex-column justify-content-start text-left">
                        <h6 class="mb-2">Average Answered<br>Time</h6>
                        <span>{{ (formatAvgTime((call_count.avg_wait_time))) }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-md-3" v-for="(item, i) in summary_lists" :key="i">
                <div class="card m-1">
                  <div class="card-body">
                    <h6 class="mb-3">{{ item.pricing_category.includes('|') ? pricing_category_short[item.pricing_category.split('|')[0]] : pricing_category_short[item.pricing_category] }}</h6>
                    <p>{{ formatStatus(item.channel_type) }}</p>
                    <h5>Rp. {{ parseFloat(item.estimated_usage).toLocaleString('id-ID') }}</h5>
                    <span>{{ item.total.toLocaleString('id-ID') }} session(s)</span>
                  </div>
                </div>
              </div>
              <div class="col-md-3" v-if="summary_lists.length">
                <div class="card m-1">
                  <div class="card-body">
                    <h6 class="mb-3">Total</h6>
                    <h5>Rp. {{ summary_lists.reduce((prev, val) => prev + parseFloat(val.estimated_usage), 0).toLocaleString('id-ID') }}</h5>
                    <span>{{ summary_lists.reduce((prev, val) => prev + parseFloat(val.total), 0).toLocaleString('id-ID') }} session(s)</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row chart-by mb-2">
              <div class="col-md-3">
                <div class="card">
                  <div class="card-body" v-loading="loading.group_agent" style="min-height: 380px;">
                    <div class="card-head mb-3">
                      <h5 class="float-left">By group</h5>
                      <!-- <a href="#" class="float-right">Details</a> -->
                    </div>
                    <apexchart v-if="!isEmpty(group_chart_options.series.filter(v => v > 0))" height="300" id="apexpie" :options="group_chart_options" :series="group_chart_options.series"></apexchart>
                    <el-empty v-else description="No data"></el-empty>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="card">
                  <div class="card-body" v-loading="loading.agent" style="min-height: 380px;">
                    <div class="card-head mb-3">
                      <h5 class="float-left">By agent</h5>
                      <!-- <a href="#" class="float-right">More Details</a> -->
                    </div>
                    <apexchart v-if="!isEmpty(agent_chart_options.series.filter(v => v > 0))" height="300" :options="agent_chart_options" :series="agent_chart_options.series"></apexchart>
                    <el-empty v-else description="No data"></el-empty>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="card">
                  <div class="card-body" v-loading="loading.label" style="min-height: 380px;">
                    <div class="card-head mb-3">
                      <h5 class="float-left">By label</h5>
                      <!-- <a href="#" class="float-right">More Details</a> -->
                    </div>
                    <apexchart v-if="!isEmpty(label_chart_options.series.filter(v => v > 0))" height="300" :options="label_chart_options" :series="label_chart_options.series"></apexchart>
                    <el-empty v-else description="No data"></el-empty>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="card">
                  <div class="card-body" v-loading="loading.channel" style="min-height: 380px;">
                    <div class="card-head mb-3">
                      <h5 class="float-left">By channel</h5>
                      <!-- <a href="#" class="float-right">More Details</a> -->
                    </div>
                    <apexchart v-if="!isEmpty(channel_chart_options.series.filter(v => v > 0))" height="300" :options="channel_chart_options" :series="channel_chart_options.series"></apexchart>
                    <el-empty v-else description="No data"></el-empty>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-3">
                <div class="card">
                  <div class="card-body" v-loading="loading.status_call_chart" style="min-height: 380px;">
                    <div class="card-head mb-3">
                      <h5 class="float-left">Status Incoming Call</h5>
                    </div>
                    <apexchart v-if="status_incoming_call_chart_options.series.length" height="300" :options="status_incoming_call_chart_options" :series="status_incoming_call_chart_options.series"></apexchart>
                    <el-empty v-else description="No data"></el-empty>
                  </div>
                </div>
              </div>
              <div class="col-3">
                <div class="card">
                  <div class="card-body" v-loading="loading.status_call_chart" style="min-height: 380px;">
                    <div class="card-head mb-3">
                      <h5 class="float-left">Status Outgoing Call</h5>
                    </div>
                    <apexchart v-if="status_outgoing_call_chart_options.series.length" height="300" :options="status_outgoing_call_chart_options" :series="status_outgoing_call_chart_options.series"></apexchart>
                    <el-empty v-else description="No data"></el-empty>
                  </div>
                </div>
              </div>
              <div class="col-3">
                <div class="card">
                  <div class="card-body" style="min-height: 380px;">
                    <div class="card-head mb-3">
                      <h5 class="float-left">SLA Call First Response Time</h5>
                    </div>
                    <apexchart v-if="sla_call_first_resp_options.series.length" height="300" :options="sla_call_first_resp_options" :series="sla_call_first_resp_options.series"></apexchart>
                    <el-empty v-else description="No data"></el-empty>
                    <!-- <apexchart v-if="status_call_chart_options.series[0] || status_call_chart_options.series[1]" height="300" :options="status_call_chart_options" :series="status_call_chart_options.series"></apexchart> -->
                    <!-- <el-empty v-else description="No data"></el-empty> -->
                  </div>
                </div>
              </div>
              <div class="col-3">
                <div class="card">
                  <div class="card-body" style="min-height: 380px;">
                    <div class="card-head mb-3">
                      <h5 class="float-left">SLA Call Resolution Time</h5>
                    </div>
                    <apexchart v-if="sla_call_resolution_options.series.length" height="300" :options="sla_call_resolution_options" :series="sla_call_resolution_options.series"></apexchart>
                    <el-empty v-else description="No data"></el-empty>
                    <!-- <apexchart v-if="status_call_chart_options.series[0] || status_call_chart_options.series[1]" height="300" :options="status_call_chart_options" :series="status_call_chart_options.series"></apexchart> -->
                    <!-- <el-empty v-else description="No data"></el-empty> -->
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-6">
                <div class="card">
                  <div class="card-body" style="min-height: 380px;">
                    <div class="card-head mb-3">
                      <h5 class="float-left">SLA Ticket First Response Time</h5>
                    </div>
                    <apexchart v-if="sla_ticket_first_resp_options.series.length" height="300" :options="sla_ticket_first_resp_options" :series="sla_ticket_first_resp_options.series"></apexchart>
                    <el-empty v-else description="No data"></el-empty>
                    <!-- <apexchart v-if="status_call_chart_options.series[0] || status_call_chart_options.series[1]" height="300" :options="status_call_chart_options" :series="status_call_chart_options.series"></apexchart> -->
                    <!-- <el-empty v-else description="No data"></el-empty> -->
                  </div>
                </div>
              </div>
              <div class="col-6">
                <div class="card">
                  <div class="card-body" style="min-height: 380px;">
                    <div class="card-head mb-3">
                      <h5 class="float-left">SLA Ticket Resolution Time</h5>
                    </div>
                    <apexchart v-if="sla_ticket_resolution_options.series.length" height="300" :options="sla_ticket_resolution_options" :series="sla_ticket_resolution_options.series"></apexchart>
                    <el-empty v-else description="No data"></el-empty>
                    <!-- <apexchart v-if="status_call_chart_options.series[0] || status_call_chart_options.series[1]" height="300" :options="status_call_chart_options" :series="status_call_chart_options.series"></apexchart> -->
                    <!-- <el-empty v-else description="No data"></el-empty> -->
                  </div>
                </div>
              </div>
            </div>

            <div class="row mt-2">
              <div class="col-12">
                <div class="card w-100">
                  <div class="card-body" v-loading="loading.agent_ticket" style="min-height: 380px;">
                    <div class="card-head mb-3">
                      <h5 class="float-left">Agent Ticket Summary</h5>
                      <!-- <a href="#" class="float-right">Details</a> -->
                    </div>
                    <div class="table-responsive">
                      <table class="table table-hover">
                        <thead>
                          <tr>
                            <th>Name</th>
                            <!-- <th>Email</th> -->
                            <!-- <th>Last Login Date</th> -->
                            <th>Availibility Status</th>
                            <th>Last Online Date</th>
                            <th>Last Offline Date</th>
                            <th>Open Ticket</th>
                            <th>Handling Ticket</th>
                            <th>Resolved Ticket</th>
                            <th>Total Ticket</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="agent in agentList" :key="agent.id" style="cursor: pointer">
                            <td>{{ agent.name }}</td>
                            <!-- <td>{{ agent.last_login_at_str }}</td> -->
                            <td>
                              <el-badge is-dot :type="agent.is_available ? 'success' : 'danger'"></el-badge>
                              {{ statusTicketAgent(agent) }}
                            </td>
                            <td>{{ agent.last_online_at_str }}</td>
                            <td>{{ agent.last_offline_at_str }}</td>
                            <td>{{ agent.total_open }}</td>
                            <td>{{ agent.total_handling }}</td>
                            <td>{{ agent.total_resolved }}</td>
                            <td>{{ agent.total_ticket }}</td>
                          </tr>
                          <tr style="cursor: pointer">
                            <td class="font-weight-bold">Total All Ticket</td>
                            <td colspan="3"></td>
                            <td>
                              {{ ticket_summary.total_open }}
                            </td>
                            <td>
                              {{ ticket_summary.total_handling }}
                            </td>
                            <td>
                              {{ ticket_summary.total_resolved }}
                            </td>
                            <td>
                              {{ ticket_summary.total_all }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <!-- <el-empty v-if="totalRow == 0" description="No data"></el-empty> -->
                    <!-- <b-pagination v-if="totalRow > search_agent.per_page" v-model="currentPage" :total-rows="totalRow" :per-page="search_agent.per_page"/> -->
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-6">
                <div class="card">
                  <div class="card-body" style="min-height: 380px;">
                    <div class="card-head mb-3">
                      <h5 class="float-left">Longest Wait Time</h5>
                    </div>
                    <el-empty description="No data"></el-empty>
                    <!-- <apexchart v-if="status_call_chart_options.series[0] || status_call_chart_options.series[1]" height="300" :options="status_call_chart_options" :series="status_call_chart_options.series"></apexchart> -->
                    <!-- <el-empty v-else description="No data"></el-empty> -->
                  </div>
                </div>
              </div>
              <div class="col-6">
                <div class="card">
                  <div class="card-body" style="min-height: 380px;">
                    <div class="card-head mb-3">
                      <h5 class="float-left">Current Calls In Queue</h5>
                    </div>
                    <el-empty description="No data"></el-empty>
                    <!-- <apexchart v-if="status_call_chart_options.series[0] || status_call_chart_options.series[1]" height="300" :options="status_call_chart_options" :series="status_call_chart_options.series"></apexchart> -->
                    <!-- <el-empty v-else description="No data"></el-empty> -->
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-12">
                <div class="card">
                  <div class="card-body" v-loading="loading.broadcast_analytic_chart" style="min-height: 380px;">
                    <div class="card-head mb-3">
                      <h5 class="float-left">Broadcast Analytics</h5>
                    </div>
                    <apexchart ref="broadcast_analytic_chart" :options="broadcast_analytic_options" :series="broadcast_analytic_options.series" height="250px"></apexchart>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-12">
                <div class="card">
                  <div class="card-body" v-loading="loading.calls_analytic_chart" style="min-height: 380px;">
                    <div class="card-head mb-3">
                      <h5 class="float-left">Channel Session Whatsapp Analytics</h5>
                    </div>
                    <apexchart ref="chart_analytics_whatsapp" :options="channel_session_options" :series="channel_session_options.series" height="250px"></apexchart>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-12">
                <div class="card">
                  <div class="card-body" v-loading="loading.calls_analytic_chart" style="min-height: 380px;">
                    <div class="card-head mb-3">
                      <h5 class="float-left">Channel Session Email Analytics</h5>
                    </div>
                    <apexchart ref="chart_analytics_email" :options="channel_session_email_options" :series="channel_session_email_options.series" height="250px"></apexchart>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="row mt-2">
              <div class="col-12">
                <div class="card">
                  <div class="card-body" v-loading="loading.calls_analytic_chart" style="min-height: 380px;">
                    <div class="card-head mb-3">
                      <h5 class="float-left">Channel Session Sms Analytics</h5>
                    </div>
                    <apexchart ref="chart_analytics_sms" :options="channel_session_sms_options" :series="channel_session_sms_options.series" height="250px"></apexchart>
                  </div>
                </div>
              </div>
            </div> -->
            <div class="row mt-2">
              <div class="col-12">
                <div class="card w-100">
                  <!-- <div class="card-body" v-loading="loading.broadcast_template_message" style="min-height: 380px;"> -->
                  <div class="card-body" style="min-height: 380px;">
                    <div class="card-head mb-3">
                      <h5 class="float-left">Broadcast Template Summary</h5>
                    </div>
                    <div class="table-responsive">
                      <table class="table table-hover">
                        <thead>
                          <tr>
                            <th>Template Name</th>
                            <th>Total Sent</th>
                            <th>Total Delivered</th>
                            <th>Total Read</th>
                            <th>Total Failed</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item, index) in template_status.data" :key="index">
                            <td>{{ item.template_name }}</td>
                            <td>{{ item.sent }}</td>
                            <td>{{ item.delivered }}</td>
                            <td>{{ item.read }}</td>
                            <td>{{ item.failed }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <el-empty v-if="template_status.totalRow == 0" description="No data"></el-empty>
                    <!-- <b-pagination v-if="template_status.totalRow > template_status.per_page" v-model="currentPageTemplateSummary" :total-rows="template_status.totalRow" :per-page="template_status.per_page"/> -->
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-12">
                <div class="card">
                  <!-- <div class="card-body" v-loading="loading.calls_analytic_chart" style="min-height: 380px;"> -->
                  <div class="card-body" style="min-height: 380px;">
                    <div class="card-head mb-3">
                      <h5 class="float-left">Ticket Resolved</h5>
                    </div>
                    <apexchart ref="tickets_analytic_chart" :options="tickets_analytic_options" :series="tickets_analytic_options.series" height="250px"></apexchart>
                    <!-- <apexchart v-if="!isEmpty(group_chart_options.series.filter(v => v > 0))" height="300" id="apexpie" :options="group_chart_options" :series="group_chart_options.series"></apexchart>
                    <el-empty v-else description="No data"></el-empty> -->
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-12">
                <div class="card">
                  <!-- <div class="card-body" v-loading="loading.calls_analytic_chart" style="min-height: 380px;"> -->
                  <div class="card-body" style="min-height: 380px;">
                    <div class="card-head mb-3">
                      <h5 class="float-left">Calls Analytics</h5>
                    </div>
                    <apexchart ref="calls_analytic_chart" :options="calls_analytic_options" :series="calls_analytic_options.series" height="250px"></apexchart>
                    <!-- <apexchart v-if="!isEmpty(group_chart_options.series.filter(v => v > 0))" height="300" id="apexpie" :options="group_chart_options" :series="group_chart_options.series"></apexchart>
                    <el-empty v-else description="No data"></el-empty> -->
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="row mt-2">
              <div class="col-12">
                <div class="card w-100"> -->
                  <!-- <div class="card-body" v-loading="loading.broadcast_template_message" style="min-height: 380px;"> -->
                  <!-- <div class="card-body" style="min-height: 380px;">
                    <div class="card-head mb-3">
                      <h5 class="float-left">Channel Session Summary</h5>
                    </div>
                    <div class="table-responsive">
                      <table class="table table-hover">
                        <thead>
                          <tr>
                            <th>Category</th>
                            <th>Total</th>
                            <th>Estimated Usage</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item, index) in channel_session.data" :key="index">
                            <td>{{ item.pricing_category }}</td>
                            <td>{{ item.total }}</td>
                            <td>Rp. {{ parseInt(item.estimated_usage) ? parseInt(item.estimated_usage).toLocaleString('id-ID') : 0 }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div> -->
                    <!-- <el-empty v-if="channel_session.totalRow == 0" description="No data"></el-empty> -->
                    <!-- <b-pagination v-if="channel_session.totalRow > channel_session.per_page" v-model="currentPageChannelSessionSummary" :total-rows="channel_session.totalRow" :per-page="channel_session.per_page"/> -->
                  <!-- </div>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <modalReminderMMLite
      :show="showModalReminderMMLite"
      :loading="loading.submit_mmlite"
      :step="mm_lite_step"
      @onHide="showModalReminderMMLite = false"
      @onSubmit="submitMMLite()"
    ></modalReminderMMLite>
    <b-modal v-model="checkOffboard"
      centered
      hide-footer
      title="Reminder Offboarding"
      :static="true"
      >
      <div>
        <div class="d-block text-center mb-2">
          This workspace has been <b>Offboarded</b> and outbound messaging is currently inactive.
          You can still access this dashboard until <b>{{ offboardDate }}</b>.
        </div>
        <div class="d-block text-center mb-2">
          To reactivate the workspace, please contact your Business PIC or email <b>commercial@mariworks.id</b>.
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  orderBy, isEmpty, uniqBy, upperFirst, startCase,
} from 'lodash';
import moment from 'moment';
import humanizeDuration from 'humanize-duration';
import analyticApi from '../../api/analytics';
import channelsAPI from '../../api/channels';
import popupErrorMessages from '../../library/popup-error-messages';
import agents from '../../api/agents';
import modalReminderMMLite from '../components/ReminderMMLite.vue';
import MariChatBanner from '../components/MariChatBanner.vue';

export default {
  components: {
    modalReminderMMLite,
    MariChatBanner,
  },
  beforeCreate() {
    this.isEmpty = isEmpty;
    this.humanizeDuration = humanizeDuration;
  },
  name: 'Dashboard',
  metaInfo: {
    title: 'Dashboard',
  },
  data() {
    return {
      agentList: [],
      ticket_summary: {
        total_open: 0,
        total_handling: 0,
        total_resolved: 0,
        total_all: 0,
      },
      date_picker_options: {
        disabledDate: (time) => {
          const today = moment();
          const diff = today.diff(moment(time), 'd');
          if (diff > 90 || diff < 0) {
            return true;
          }
          if (diff === 0) {
            if (today.isSame(moment(time), 'd') === false) {
              return true;
            }
          }
          return false;
        },
        shortcuts: [
          {
            text: 'Today',
            onClick(picker) {
              const start = moment().startOf('day').format();
              const end = moment().format();
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: 'This week',
            onClick(picker) {
              const start = moment().startOf('week').format();
              const end = moment().format();
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: 'This month',
            onClick(picker) {
              const start = moment().startOf('month').format();
              const end = moment().format();
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: 'Last week',
            onClick(picker) {
              const start = moment().subtract(1, 'week').startOf('week').format();
              const end = moment().subtract(1, 'week').endOf('week').format();
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: 'Last month',
            onClick(picker) {
              const start = moment().subtract(1, 'month').startOf('month').format();
              const end = moment().subtract(1, 'month').endOf('month').format();
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },
      filter_by_list: [
        {
          label: 'This month',
          value: 'this_month',
        },
        {
          label: 'Last month',
          value: 'last_month',
        },
        {
          label: 'Today',
          value: 'today',
        },
        {
          label: 'Yesterday',
          value: 'yesterday',
        },
        {
          label: 'This week',
          value: 'this_week',
        },
        {
          label: 'Last week',
          value: 'last_week',
        },
      ],
      filter: {
        date_type: 'this_month',
        date_range: [
          moment().subtract(7, 'days').format(),
          moment().format(),
        ],
      },
      loading: {
        all: true,
        label: true,
        agent: true,
        group_agent: true,
        channel: true,
        agent_ticket: true,
        broadcast_analytic_chart: true,
        broadcast_template_message: true,
        calls_analytic_chart: true,
        calls_analytic_duration: true,
        tickets_analytic_chart: true,
        template_message_summary: true,
        channel_session_summary: true,
        call_total_percentage: true,
        agent_activity: true,
        conversations_avg_time: true,
        channel_session_price: true,
        channel_session_chart: true,
        status_call_chart: true,
        total_status_calls: true,
        total_status_leads: true,
        total_status_conversations: true,
        sla_call_chart: true,
        sla_ticket_chart: true,
        longest_wait_time: true,
        calls_queue: true,
        submit_mmlite: false,
      },
      loader: null,
      loaderStack: 0,
      leads_count: {
        open: 0,
        close: 0,
      },
      conversation_status_count: {
        open: 0,
        handling: 0,
        resolved: 0,
      },
      calls_count: {
        inbound: 0,
        outbond: 0,
      },
      message_count: {
        inbound: 0,
        outbond: 0,
      },
      ticket_count: {
        all: 0,
      },
      contact_count: 0,
      call_count: {
        avg_incoming: 0,
        avg_outgoing: 0,
        avg_all: 0,
        avg_wait_time: 0,
      },
      conversation_count: {
        avg_first_time_response: 0,
        avg_resolved_time: 0,
      },
      label_chart_options: {
        chart: {
          height: 400,
          type: 'donut',
        },
        stroke: {
          colors: ['rgba(0,0,0,0)'],
        },
        labels: ['dummy1', 'dummy2', 'dummy3', 'dummy4'],
        colors: ['#f77eb9', '#7ee5e5', '#4d8af0', '#fbbc06'],
        legend: {
          position: 'bottom',
          horizontalAlign: 'center',
        },
        dataLabels: {
          enabled: true,
        },
        series: [],
        tooltip: {
          fixed: {
            enabled: true,
          },
        },
        showTooltips: false,
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
              },
              total: {
                show: false,
                showAlways: false,
                label: 'Total',
                fontSize: '22px',
                fontFamily: 'Helvetica, Arial, sans-serif',
                fontWeight: 600,
                color: '#373d3f',
                formatter: (w) => w.globals.seriesTotals.reduce((a, b) => a + b, 0),
              },
            },
          },
        },
      },
      agent_chart_options: {
        chart: {
          height: 400,
          type: 'pie',
        },
        stroke: {
          colors: ['rgba(0,0,0,0)'],
        },
        labels: [],
        colors: ['#7cb6ef', '#81d2d3', '#4d8af0', '#fbbc06', '#F47983'],
        legend: {
          position: 'bottom',
          horizontalAlign: 'center',
        },
        dataLabels: {
          enabled: true,
        },
        series: [],
        tooltip: {
          fixed: {
            enabled: true,
          },
        },
      },
      group_chart_options: {
        chart: {
          height: 400,
          type: 'donut',
        },
        stroke: {
          colors: ['rgba(0,0,0,0)'],
        },
        labels: [],
        colors: ['#81d2d3', '#7eb512', '#4d8af0', '#fbbc06', '#F47983'],
        legend: {
          position: 'bottom',
          horizontalAlign: 'center',
        },
        dataLabels: {
          enabled: true,
        },
        tooltip: {
          fixed: {
            enabled: true,
          },
        },
        series: [],
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
              },
              total: {
                show: false,
                showAlways: false,
                label: 'Total',
                fontSize: '22px',
                fontFamily: 'Helvetica, Arial, sans-serif',
                fontWeight: 600,
                color: '#373d3f',
                formatter: (w) => w.globals.seriesTotals.reduce((a, b) => a + b, 0),
              },
            },
          },
        },
      },
      channel_chart_options: {
        chart: {
          height: 400,
          type: 'pie',
        },
        stroke: {
          colors: ['rgba(0,0,0,0)'],
        },
        tooltip: {
          fixed: {
            enabled: true,
          },
        },
        labels: [],
        colors: ['#f77eb9', '#7ee5e5', '#4d8af0', '#fbbc06', '#F47983'],
        legend: {
          position: 'bottom',
          horizontalAlign: 'center',
        },
        dataLabels: {
          enabled: true,
        },
        series: [],
      },
      broadcast_analytic_options: {
        chart: {
          height: 250,
          type: 'area',
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          width: [1, 1, 1, 1],
          curve: 'smooth',
        },
        xaxis: {},
        yaxis: {
          min: 0,
          title: {
            text: 'Total Status Broadcast',
          },
        },
        fill: {
          opacity: 5,
        },
        tooltip: {
          shared: true,
          y: {
            formatter: (val) => val.toLocaleString('id-ID'),
          },
        },
      },
      status_incoming_call_chart_options: {
        series: [],
        labels: [],
        chart: {
          height: 400,
          type: 'pie',
        },
        stroke: {
          colors: ['rgba(0,0,0,0)'],
        },
        legend: {
          position: 'bottom',
          horizontalAlign: 'center',
        },
        dataLabels: {
          enabled: true,
        },
      },
      status_outgoing_call_chart_options: {
        series: [],
        labels: [],
        chart: {
          height: 400,
          type: 'pie',
        },
        stroke: {
          colors: ['rgba(0,0,0,0)'],
        },
        legend: {
          position: 'bottom',
          horizontalAlign: 'center',
        },
        dataLabels: {
          enabled: true,
        },
      },
      calls_analytic_options: {
        series: [],
        colors: [],
        chart: {
          height: 250,
          type: 'area',
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          width: [1, 1, 1, 1],
          curve: 'smooth',
        },
        xaxis: {},
        yaxis: {
          min: 0,
          title: {
            text: 'Status Calls',
          },
        },
        fill: {
          opacity: 5,
        },
        tooltip: {
          shared: true,
          y: {
            formatter: (val) => val.toLocaleString('id-ID'),
          },
        },
      },
      sla_call_first_resp_options: {
        labels: [],
        series: [],
        chart: {
          height: 400,
          type: 'pie',
        },
        stroke: {
          colors: ['rgba(0,0,0,0)'],
        },
        legend: {
          position: 'bottom',
          horizontalAlign: 'center',
        },
        dataLabels: {
          enabled: true,
        },
      },
      sla_call_resolution_options: {
        labels: [],
        series: [],
        chart: {
          height: 400,
          type: 'pie',
        },
        stroke: {
          colors: ['rgba(0,0,0,0)'],
        },
        legend: {
          position: 'bottom',
          horizontalAlign: 'center',
        },
        dataLabels: {
          enabled: true,
        },
      },
      sla_ticket_first_resp_options: {
        series: [],
        labels: [],
        chart: {
          height: 400,
          type: 'pie',
        },
        stroke: {
          colors: ['rgba(0,0,0,0)'],
        },
        legend: {
          position: 'bottom',
          horizontalAlign: 'center',
        },
        dataLabels: {
          enabled: true,
        },
      },
      sla_ticket_resolution_options: {
        series: [],
        labels: [],
        chart: {
          height: 400,
          type: 'pie',
        },
        stroke: {
          colors: ['rgba(0,0,0,0)'],
        },
        legend: {
          position: 'bottom',
          horizontalAlign: 'center',
        },
        dataLabels: {
          enabled: true,
        },
      },
      tickets_analytic_options: {
        series: [],
        colors: [],
        chart: {
          height: 250,
          type: 'area',
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          width: [1, 1, 1, 1],
          curve: 'smooth',
        },
        xaxis: {},
        yaxis: {
          min: 0,
          title: {
            text: 'Total Ticket Resolved',
          },
        },
        fill: {
          opacity: 5,
        },
        tooltip: {
          shared: true,
          y: {
            formatter: (val) => val.toLocaleString('id-ID'),
          },
        },
      },
      channel_session_options: {
        chart: {
          height: 250,
          type: 'area',
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          width: [1, 1, 1, 1],
          curve: 'smooth',
        },
        xaxis: {},
        yaxis: {
          min: 0,
          title: {
            text: 'Total Whatsapp Session',
          },
        },
        fill: {
          opacity: 5,
        },
        tooltip: {
          shared: true,
          y: {
            formatter: (val) => val.toLocaleString('id-ID'),
          },
        },
      },
      channel_session_whatsapp_options: {
        chart: {
          height: 250,
          type: 'area',
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          width: [1, 1, 1, 1],
          curve: 'smooth',
        },
        xaxis: {},
        yaxis: {
          min: 0,
          title: {
            text: 'Total Whatsapp Session',
          },
        },
        fill: {
          opacity: 5,
        },
        tooltip: {
          shared: true,
          y: {
            formatter: (val) => val.toLocaleString('id-ID'),
          },
        },
      },
      channel_session_email_options: {
        chart: {
          height: 250,
          type: 'area',
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          width: [1, 1, 1, 1],
          curve: 'smooth',
        },
        xaxis: {},
        yaxis: {
          min: 0,
          title: {
            text: 'Total Email Session',
          },
        },
        fill: {
          opacity: 5,
        },
        tooltip: {
          shared: true,
          y: {
            formatter: (val) => val.toLocaleString('id-ID'),
          },
        },
      },
      // channel_session_sms_options: {
      //   chart: {
      //     height: 250,
      //     type: 'area',
      //     zoom: {
      //       enabled: false,
      //     },
      //   },
      //   dataLabels: {
      //     enabled: false,
      //   },
      //   stroke: {
      //     width: [1, 1, 1, 1],
      //     curve: 'smooth',
      //   },
      //   xaxis: {},
      //   yaxis: {
      //     min: 0,
      //     title: {
      //       text: 'Total Sms Session',
      //     },
      //   },
      //   fill: {
      //     opacity: 5,
      //   },
      //   tooltip: {
      //     shared: true,
      //     y: {
      //       formatter: (val) => val.toLocaleString('id-ID'),
      //     },
      //   },
      // },
      search_agent: {
        page: 1,
        per_page: 10,
      },
      template_status: {
        data: [],
        page: 1,
        per_page: 10,
        totalRow: 0,
      },
      channel_session: {
        data: [],
        page: 1,
        per_page: 10,
        totalRow: 0,
      },
      count_answered_unswered: {
        total: 0,
        answered: 0,
        unswered: 0,
        answered_percentage: 0,
        unswered_percentage: 0,
      },
      count_status_call: {
        incoming: {},
        outgoing: {},
      },
      summary_lists: [],
      pricing_category_short: {
        user_initiated: 'UI',
        business_initiated: 'BI',
        service_conversation: 'Service Conv.',
        marketing_conversation: 'Marketing Conv.',
        marketing_lite_conversation: 'Marketing Conv.',
        utility_conversation: 'Utility Conv.',
        authentication_conversation: 'Authentication Conv.',
        referral_conversion: 'Referral Conv.',
        service: 'Service Conv.',
        marketing: 'Marketing Conv.',
        utility: 'Utility Conv.',
        authentication: 'Authentication Conv.',
        incoming_call: 'Incoming call',
        outgoing_call: 'Outgoing call',
        marketing_message: 'Marketing Message',
        marketing_lite_message: 'Marketing Message',
        utility_message: 'Utility Message',
        authentication_message: 'Authentication Message',
        regular: 'Regular',
        otp: 'OTP',
      },
      showModalReminderMMLite: false,
      showModalReminderOffboard: false,
      mm_lite_step: 1,
    };
  },
  async mounted() {
    this.showLoader();
    await this.loadAllAnalytic();
    await this.checkMMLite();
    this.hideLoader();
  },
  computed: {
    workspaces() {
      return this.$store.state.workspace.workspaces.map((workspace) => ({
        text: workspace.name,
        value: workspace._id,
      }));
    },
    activeWorkspace() {
      return this.$store.state.workspace.activeWorkspace;
    },
    offboardDate() {
      const period = moment(this.activeWorkspace.invoicing_info?.offboarded_at).add(1, 'month').format('YYYY-MM-DD');
      return period;
    },
    checkOffboard() {
      return this.activeWorkspace.invoicing_info?.offboarded;
    },
    currentPage: {
      get() {
        return this.search_agent.page;
      },
      set(val) {
        this.search_agent.page = val;
        this.getAgentList();
      },
    },
    currentPageTemplateSummary: {
      get() {
        return this.template_status.page;
      },
      set(val) {
        this.template_status.page = val;
        this.getTemplateMessageStatus();
      },
    },
    currentPageChannelSessionSummary: {
      get() {
        return this.channel_session.page;
      },
      set(val) {
        this.channel_session.page = val;
        this.getChannelSessionSummary();
      },
    },
  },
  methods: {
    formatStatus(text) {
      return startCase(text);
    },
    formatAvgTime(seconds) {
      const ms = parseInt(seconds) * 1000;
      const units = ms >= 86400000
        ? ['d', 'h', 'm']
        : ['h', 'm', 's'];
      return humanizeDuration(ms, {
        units,
        round: true,
        language: 'en',
      });
    },
    async loadAllAnalytic() {
      await this.getAnalytic();
      this.getAgentList();
      this.getInOutMessages();
      this.getChartBroadcast();
      this.getCallChart();
      this.getCallDuration();
      this.getConversationResolvedChart();
      this.getTemplateMessageStatus();
      // this.getChannelSessionSummary();
      this.getResolvedTime('resolve_time');
      this.getResolvedTime('first_response_time');
      this.getChannelSessionPrice();
      this.getChannelChart();
      this.getInOutCalls();
      this.getStatusConversations();
      this.getStatusLeads();
      this.getStatusCall();
      this.getStatusSlaCall();
      this.getStatusSlaTicket();
    },
    getDateRange() {
      const start_date = this.filter.date_range[0] || moment().format();
      const end_date = this.filter.date_range[1] || moment().format();
      const start_day = moment(start_date).startOf('day');
      const end_day = moment(end_date).endOf('day');
      const gapDays = end_day.diff(start_day, 'days');
      return {
        start_date,
        end_date,
        start_day,
        end_day,
        gapDays,
      };
    },
    dateCheck() {
      const [start_date, end_date] = this.filter.date_range;
      const minTime = moment(start_date);
      const maxTime = moment(end_date);
      const diff = maxTime.diff(moment(minTime), 'd');
      if (diff > 30) {
        this.$message({
          title: this.$t('general.error.general'),
          type: 'warning',
          message: 'Reporting period that can be selected for 31 days',
          duration: 20 * 100,
          showClose: true,
        });
        this.filter.date_range = [start_date, start_date];
      }
      this.loadAllAnalytic();
    },
    async getChartBroadcast() {
      this.loading.broadcast_analytic_chart = true;
      const {
        start_date,
        end_date,
        start_day,
        end_day,
        gapDays,
      } = this.getDateRange();
      let labels = {
        format: 'dd MMM',
        showDuplicates: false,
        hideOverlappingLabels: false,
      };
      if (gapDays === 30) {
        labels = {
          formatter(value) {
            return moment(value).format('D MMM');
          },
          showDuplicates: false,
          hideOverlappingLabels: false,
        };
      }
      this.broadcast_analytic_options.xaxis = {
        type: 'datetime',
        min: new Date(start_day).getTime(),
        max: new Date(end_day).getTime(),
        tickAmount: gapDays,
        labels,
      };
      if (moment(end_date).isAfter(moment(), 'day')) {
        this.broadcast_analytic_options.xaxis.max = new Date(moment().format('YYYY-MM-DD')).getTime();
      }
      const response = await analyticApi.broadcastChart({
        workspace_id: this.activeWorkspace._id,
        start_date,
        end_date,
      });
      await popupErrorMessages(response);
      this.broadcast_analytic_options.series = [];
      this.broadcast_analytic_options.colors = [];
      const status_color = {
        delivered: '#B7E0FF',
        failed: '#CC2B52',
        read: '#15B392',
        sent: '#F3C623',
      };
      if (!response.error) {
        if (response.data.rows && Object.keys(response.data.rows).length) {
          const tempSeries = new Map();
          Object.values(response.data).forEach((broadcastCategory) => {
            Object.entries(broadcastCategory).forEach(([key, value]) => {
              if (!tempSeries.has(key)) {
                tempSeries.set(key, {});
              }
              const keyDate = tempSeries.get(key);
              value.forEach((v) => {
                const date = new Date(moment(v.date).format('YYYY-MM-DD')).getTime();
                if (!keyDate.date) {
                  keyDate[date] = [];
                }
                keyDate[date].push(parseInt(v.total));
              });
            });
          });
          tempSeries.forEach((value, key) => {
            const series = {
              name: upperFirst(key),
              data: [],
            };
            const dateCountMap = {};
            Object.entries(value).forEach(([key_, value_]) => {
              const dateStr = moment(parseInt(key_)).format('YYYY-MM-DD');
              dateCountMap[dateStr] = value_[0];
            });
            const current = start_day.clone();
            while (current.isSameOrBefore(end_day)) {
              const dateStr = current.format('YYYY-MM-DD');
              const timestamp = new Date(moment(current).format('YYYY-MM-DD')).getTime();
              const total = dateCountMap[dateStr] || 0;
              series.data.push([timestamp, total]);
              current.add(1, 'day');
            }
            this.broadcast_analytic_options.colors.push(status_color[key]);
            this.broadcast_analytic_options.series.push(series);
          });
        }
      }
      if (this.$refs.broadcast_analytic_chart) await this.$refs.broadcast_analytic_chart.refresh();
      this.loading.broadcast_analytic_chart = false;
    },
    async getAgentList() {
      this.loading.agent_ticket = true;
      await agents.getListSummaryTicket(this.activeWorkspace._id, {
        page: this.search_agent.page,
        per_page: this.search_agent.per_page,
      }).then(async (res) => {
        await popupErrorMessages(res);
        this.totalRow = res.data.count;
        let total_open = 0;
        let total_handling = 0;
        let total_resolved = 0;
        let total_all = 0;
        const mapped_data = res.data.rows.map((agent) => {
          const data = agent;
          data.last_online_at_str = agent.last_online_at ? moment(agent.last_online_at).format('DD MMM YYYY, HH:mm') : '-';
          data.last_offline_at_str = agent.last_offline_at ? moment(agent.last_offline_at).format('DD MMM YYYY, HH:mm') : '-';
          data.total_ticket = (parseInt(agent.total_open) || 0) + (parseInt(agent.total_handling) || 0) + parseInt((agent.total_resolved) || 0);
          total_open += parseInt(data.total_open);
          total_handling += parseInt(data.total_handling);
          total_resolved += parseInt(data.total_resolved);
          total_all += data.total_ticket;
          return data;
        });
        this.agentList = mapped_data;
        this.ticket_summary.total_open = total_open;
        this.ticket_summary.total_handling = total_handling;
        this.ticket_summary.total_resolved = total_resolved;
        this.ticket_summary.total_all = total_all;
      }).catch(() => {});
      this.loading.agent_ticket = false;
    },
    async getAnalytic() {
      this.loading.all = true;
      this.loading.label = true;
      this.loading.agent = true;
      this.loading.group_agent = true;
      this.loading.channel = true;

      const response = await analyticApi.dashboardAnalytic({
        workspace_id: this.activeWorkspace._id,
        date_type: this.filter.date_type,
      }).catch(() => {});
      this.loading.all = false;
      await popupErrorMessages(response);

      this.message_count = {
        inbound: response.data.inbound_messages[0].count,
        outbond: response.data.outbond_messages[0].count,
      };
      this.ticket_count = {
        all: response.data.tickets[0].count,
      };
      this.contact_count = {
        all: response.data.contacts[0].count,
      };
      this.renderLabel(orderBy(response.data.labels, 'count', 'desc').splice(0, 5));
      this.renderAgent(orderBy(response.data.ticket_agent, 'count', 'desc').splice(0, 5));
      this.renderGroup(orderBy(response.data.ticket_group, 'count', 'desc').splice(0, 5));
      this.renderChannel(response.data.ticket_channel);
    },
    renderLabel(data = []) {
      this.label_chart_options = {
        ...this.label_chart_options,
        colors: data.map((v) => v.color),
        series: data.map((v) => v.count),
        labels: data.map((v) => v.title),
      };
      this.loading.label = false;
    },
    renderAgent(data = []) {
      this.agent_chart_options = {
        ...this.agent_chart_options,
        series: data.map((v) => v.count),
        labels: data.map((v) => v.agent_name),
      };
      this.loading.agent = false;
    },
    renderGroup(data = []) {
      this.group_chart_options = {
        ...this.group_chart_options,
        series: data.map((v) => v.count),
        labels: data.map((v) => v.group_name),
      };
      this.loading.group_agent = false;
    },
    /* eslint-disable no-param-reassign */
    renderChannel(data = []) {
      const color = {
        whatsapp: '#26A65B',
        telegram: 'rgb(100, 187, 228)',
        sms: '#81d2d3',
      };
      data = uniqBy(data, 'channel_name');
      this.channel_chart_options = {
        ...this.channel_chart_options,
        series: data.map((v) => v.count),
        labels: data.map((v) => v.channel_name),
        colors: data.map((v) => color[v.channel_name.toLowerCase()]),
      };
      this.loading.channel = false;
    },
    showLoader() {
      if (this.loaderStack === 0) {
        this.loader = this.$loading.show();
      }
      this.loaderStack += 1;
    },
    hideLoader() {
      this.loaderStack -= 1;
      if (this.loaderStack === 0) {
        this.loader.hide();
      }
    },
    async getCallDuration() {
      this.loading.calls_analytic_duration = true;
      const start_date = this.filter.date_range[0] || moment().format();
      const end_date = this.filter.date_range[1] || moment().format();
      await analyticApi.callDuration({
        workspace_id: this.activeWorkspace._id,
        start_date,
        end_date,
      }).then(async (res) => {
        await popupErrorMessages(res);
        let total_duration_incoming = 0;
        let total_duration_outgoing = 0;
        res.data.rows.forEach((v) => {
          if (v.detail.incoming) {
            total_duration_incoming += v.detail.incoming;
          }
          if (v.detail.outgoing) {
            total_duration_outgoing += v.detail.outgoing;
          }
        });
        this.call_count = {
          avg_all: res.data.avg_call_duration,
          avg_incoming: total_duration_incoming,
          avg_outgoing: total_duration_outgoing,
          avg_wait_time: res.data.avg_incoming_wait_time,
        };
      }).catch(() => {});
      this.loading.calls_analytic_duration = false;
    },
    async getCallChart() {
      this.loading.calls_analytic_chart = true;
      const {
        start_date,
        end_date,
        start_day,
        end_day,
        gapDays,
      } = this.getDateRange();
      let labels = {
        format: 'dd MMM',
        showDuplicates: false,
        hideOverlappingLabels: false,
      };
      if (gapDays === 30) {
        labels = {
          formatter(value) {
            return moment(value).format('D MMM');
          },
          showDuplicates: false,
          hideOverlappingLabels: false,
        };
      }
      this.calls_analytic_options.xaxis = {
        type: 'datetime',
        min: new Date(start_day).getTime(),
        max: new Date(end_day).getTime(),
        tickAmount: gapDays,
        labels,
      };
      if (moment(end_date).isAfter(moment(), 'day')) {
        this.calls_analytic_options.xaxis.max = new Date(moment().format('YYYY-MM-DD')).getTime();
      }
      const response = await analyticApi.callChart({
        workspace_id: this.activeWorkspace._id,
        start_date,
        end_date,
      });
      await popupErrorMessages(response);
      this.calls_analytic_options.series = [];
      const direction_color = {
        outgoing: '#B7E0FF',
        incoming: '#CC2B52',
      };
      if (!response.error) {
        if (response.data && Object.keys(response.data).length) {
          const tempSeries = new Map();
          Object.values(response.data).forEach((channelGroup) => {
            Object.entries(channelGroup).forEach(([key, value]) => {
              if (!tempSeries.has(key)) {
                tempSeries.set(key, {});
              }
              const keyDate = tempSeries.get(key);
              value.forEach((v) => {
                const date = new Date(moment(v.call_date).format('YYYY-MM-DD')).getTime();
                if (!keyDate.date) {
                  keyDate[date] = [];
                }
                keyDate[date].push(parseInt(v.count_call));
              });
            });
          });
          tempSeries.forEach((value, key) => {
            const series = {
              name: upperFirst(key),
              data: [],
            };
            const dateCountMap = {};
            Object.entries(value).forEach(([key_, value_]) => {
              const dateStr = moment(parseInt(key_)).format('YYYY-MM-DD');
              dateCountMap[dateStr] = value_[0];
            });
            // const start = moment(this.filter.date_range[0]).startOf('day');
            // const end = moment(this.filter.date_range[1]).startOf('day');
            const current = start_day.clone();
            while (current.isSameOrBefore(end_day)) {
              const dateStr = current.format('YYYY-MM-DD');
              const timestamp = new Date(moment(current).format('YYYY-MM-DD')).getTime();
              const total = dateCountMap[dateStr] || 0;
              series.data.push([timestamp, total]);
              current.add(1, 'day');
            }
            this.calls_analytic_options.colors.push(direction_color[key]);
            this.calls_analytic_options.series.push(series);
          });
        }
        if (this.$refs.calls_analytic_chart) await this.$refs.calls_analytic_chart.refresh();
        this.loading.calls_analytic_chart = false;
      }
      this.loading.calls_analytic_chart = false;
    },
    async getConversationResolvedChart() {
      this.loading.tickets_analytic_chart = true;
      const {
        start_date,
        end_date,
        start_day,
        end_day,
        gapDays,
      } = this.getDateRange();
      let labels = {
        format: 'dd MMM',
        showDuplicates: false,
        hideOverlappingLabels: false,
      };
      if (gapDays === 30) {
        labels = {
          formatter(value) {
            return moment(value).format('D MMM');
          },
          showDuplicates: false,
          hideOverlappingLabels: false,
        };
      }
      this.tickets_analytic_options.xaxis = {
        type: 'datetime',
        min: new Date(start_day).getTime(),
        max: new Date(end_day).getTime(),
        tickAmount: gapDays,
        labels,
      };
      if (moment(end_date).isAfter(moment(), 'day')) {
        this.tickets_analytic_options.xaxis.max = new Date(moment().startOf('day')).getTime();
      }
      const response = await analyticApi.resolvedConversationChart({
        workspace_id: this.activeWorkspace._id,
        start_date,
        end_date,
        display_as: 'time_chart',
      });
      await popupErrorMessages(response);
      this.tickets_analytic_options.series = [];
      const direction_color = {
        resolved: '#B7E0FF',
      };
      if (!response.error) {
        if (response.data.rows && Object.keys(response.data.rows).length) {
          const series = {
            name: 'Resolved',
            data: [],
          };
          const dateCountMap = {};
          response.data.rows.forEach((v) => {
            const dateStr = moment(v.date).format('YYYY-MM-DD');
            dateCountMap[dateStr] = v.total;
          });
          const current = start_day.clone();
          while (current.isSameOrBefore(end_day)) {
            const dateStr = current.format('YYYY-MM-DD');
            const timestamp = new Date(moment(current).format('YYYY-MM-DD')).getTime();
            const total = dateCountMap[dateStr] || 0;
            series.data.push([timestamp, total]);
            current.add(1, 'day');
          }
          this.tickets_analytic_options.colors.push(direction_color.resolved);
          this.tickets_analytic_options.series.push(series);
        }
        if (this.$refs.tickets_analytic_chart) await this.$refs.tickets_analytic_chart.refresh();
        this.loading.tickets_analytic_chart = false;
      }
      this.loading.tickets_analytic_chart = false;
    },
    async getTemplateMessageStatus() {
      this.loading.template_message_summary = true;
      const start_date = this.filter.date_range[0] || moment().format();
      const end_date = this.filter.date_range[1] || moment().format();
      const response = await analyticApi.templateMessageStatus({
        workspace_id: this.activeWorkspace._id,
        start_date,
        end_date,
      });
      await popupErrorMessages(response);
      if (!response.error) {
        const data_template_message = response.data.rows;
        this.template_status.totalRow = data_template_message?.length;
        const { page, per_page } = this.template_status;
        const start = (page - 1) * per_page;
        const end = start + per_page;
        this.template_status.data = data_template_message?.slice(start, end);
      }
      this.loading.template_message_summary = false;
    },
    // async getChannelSessionSummary() {
    //   this.loading.channel_session_summary = true;
    //   const start_date = this.filter.date_range[0] || moment().format();
    //   const end_date = this.filter.date_range[1] || moment().format();
    //   console.log('start_date', start_date);
    //   console.log('end_date', end_date);
    //   const response = await analyticApi.channelSummary({
    //     workspace_id: this.activeWorkspace._id,
    //     start_date,
    //     end_date,
    //   });
    //   if (!response.error) {
    //     const data_channel_session = response.data.rows;
    //     this.channel_session.totalRow = data_channel_session.length;
    //     const { page, per_page } = this.channel_session;
    //     const start = (page - 1) * per_page;
    //     const end = start + per_page;
    //     this.channel_session.data = data_channel_session.slice(start, end);
    //   }
    //   this.loading.channel_session_summary = false;
    // },
    async getResolvedTime(time_type) {
      this.loading.conversations_avg_time = true;
      const start_date = this.filter.date_range[0] || moment().format();
      const end_date = this.filter.date_range[1] || moment().format();
      const response = await analyticApi.resolvedConversationTime({
        workspace_id: this.activeWorkspace._id,
        start_date,
        end_date,
        time_type,
      });
      await popupErrorMessages(response);
      if (!response.error) {
        if (time_type === 'resolve_time') {
          this.conversation_count = {
            ...this.conversation_count,
            avg_resolved_time: response.data.resolve_time,
          };
        } else if (time_type === 'first_response_time') {
          this.conversation_count = {
            ...this.conversation_count,
            avg_first_time_response: response.data.first_response_time,
          };
        }
      }
      this.loading.conversations_avg_time = false;
    },
    async getInOutMessages() {
      const start_date = this.filter.date_range[0] || moment().format();
      const end_date = this.filter.date_range[1] || moment().format();
      const response = await analyticApi.analyticInOutMessages({
        workspace_id: this.activeWorkspace._id,
        start_date,
        end_date,
      });
      await popupErrorMessages(response);
      if (!response.error) {
        this.message_count = {
          inbound: response.data.in || 0,
          outbond: response.data.out || 0,
        };
      }
    },
    async getChannelSessionPrice() {
      this.loading.channel_session_price = true;
      const start_date = this.filter.date_range[0] || moment().format();
      const end_date = this.filter.date_range[1] || moment().format();
      const response = await analyticApi.channelSummary({
        workspace_id: this.activeWorkspace._id,
        start_date,
        end_date,
      });
      await popupErrorMessages(response);
      const { data } = response;
      this.summary_lists = data.rows;
      this.loading.channel_session_price = false;
    },
    async getChannelChart() {
      this.loading.channel_session_chart = true;
      const {
        start_date,
        end_date,
        start_day,
        end_day,
        gapDays,
      } = this.getDateRange();
      let labels = {
        format: 'dd MMM',
        showDuplicates: false,
        hideOverlappingLabels: false,
      };
      if (gapDays === 30) {
        labels = {
          formatter(value) {
            return moment(value).format('D MMM');
          },
          showDuplicates: false,
          hideOverlappingLabels: false,
        };
      }
      const xaxis = {
        type: 'datetime',
        min: new Date(start_day).getTime(),
        max: new Date(end_day).getTime(),
        tickAmount: gapDays,
        labels,
      };
      this.channel_session_options.xaxis = xaxis;
      // this.channel_session_sms_options.xaxis = xaxis;
      this.channel_session_email_options.xaxis = xaxis;
      if (moment(end_date).isAfter(moment(), 'day')) {
        this.calls_analytic_options.xaxis.max = new Date(moment().format('YYYY-MM-DD')).getTime();
      }
      const response = await analyticApi.channelChart({
        workspace_id: this.activeWorkspace._id,
        start_date,
        end_date,
      });
      await popupErrorMessages(response);
      this.channel_session_options.series = [];
      this.channel_session_options.colors = [];
      // this.channel_session_sms_options.series = [];
      // this.channel_session_sms_options.colors = [];
      this.channel_session_email_options.series = [];
      this.channel_session_email_options.colors = [];
      const tempSeries = new Map();
      Object.values(response.data).forEach((channelSessionCategory) => {
        Object.entries(channelSessionCategory).forEach(([key, value]) => {
          if (!tempSeries.has(key)) {
            tempSeries.set(key, {});
          }
          const keyDate = tempSeries.get(key);
          value.forEach((v) => {
            const date = new Date(moment(v.date).format('YYYY-MM-DD')).getTime();
            if (!keyDate.date) {
              keyDate[date] = [];
            }
            keyDate[date].push(parseInt(v.total));
          });
        });
      });
      tempSeries.forEach((value, key) => {
        const name = key.replace(/_email|_sms/g, '');
        const series = {
          name: upperFirst(name),
          data: [],
        };
        const dateCountMap = {};
        Object.entries(value).forEach(([key_, value_]) => {
          const dateStr = moment(parseInt(key_)).format('YYYY-MM-DD');
          dateCountMap[dateStr] = value_[0];
        });
        const current = start_day.clone();
        while (current.isSameOrBefore(end_day)) {
          const dateStr = current.format('YYYY-MM-DD');
          const timestamp = new Date(moment(current).format('YYYY-MM-DD')).getTime();
          const total = dateCountMap[dateStr] || 0;
          series.data.push([timestamp, total]);
          current.add(1, 'day');
        }
        if (key.includes('email')) {
          this.channel_session_email_options.colors.push(this.getRandomColor());
          this.channel_session_email_options.series.push(series);
        } else {
          this.channel_session_options.colors.push(this.getRandomColor());
          this.channel_session_options.series.push(series);
        }
        // else if (key.includes('sms')) {
        //   this.channel_session_sms_options.colors.push(this.getRandomColor());
        //   this.channel_session_sms_options.series.push(series);
        // }
      });
      if (this.$refs.chart_analytics_whatsapp) await this.$refs.chart_analytics_whatsapp.refresh();
      if (this.$refs.chart_analytics_email) await this.$refs.chart_analytics_email.refresh();
      // if (this.$refs.chart_analytics_sms) await this.$refs.chart_analytics_sms.refresh();
      this.loading.channel_session_chart = false;
    },
    getRandomColor() {
      const color = Math.floor(Math.random() * 16777215).toString(16).padStart(6, '0');
      return `#${color}`;
    },
    statusTicketAgent(agent) {
      if (agent.is_available && agent.active_call_id && agent.active_call_at) {
        return 'Talking';
      }
      if (agent.is_available) {
        return 'Online';
      }
      return 'Offline';
    },
    async getStatusConversations() {
      this.loading.total_status_conversations = true;
      const start_date = this.filter.date_range[0] || moment().format();
      const end_date = this.filter.date_range[1] || moment().format();
      const response = await analyticApi.statusConversations({
        workspace_id: this.activeWorkspace._id,
        start_date,
        end_date,
      });
      if (!response.error) {
        this.conversation_status_count = {
          open: response.data.total_open || 0,
          handling: response.data.total_handled || 0,
          resolved: response.data.total_resolved || 0,
        };
      }
      this.loading.total_status_conversations = false;
    },
    async getInOutCalls() {
      this.loading.total_status_calls = true;
      const start_date = this.filter.date_range[0] || moment().format();
      const end_date = this.filter.date_range[1] || moment().format();
      const response = await analyticApi.analyticInOutCalls({
        workspace_id: this.activeWorkspace._id,
        start_date,
        end_date,
      });
      if (!response.error && response.data) {
        this.calls_count = {
          inbound: response.data.incoming || 0,
          outbond: response.data.outgoing || 0,
        };
      }
      this.loading.total_status_calls = true;
    },
    async getStatusLeads() {
      this.loading.total_status_leads = true;
      const start_date = this.filter.date_range[0] || moment().format();
      const end_date = this.filter.date_range[1] || moment().format();
      const response = await analyticApi.statusLeads({
        workspace_id: this.activeWorkspace._id,
        start_date,
        end_date,
      });
      if (!response.error) {
        const data_count = response.data;
        this.leads_count = {
          open: data_count.total_open || 0,
          close: data_count.total_close || 0,
        };
      }
      this.loading.total_status_leads = false;
    },
    async getStatusCall() {
      this.loading.status_call_chart = true;
      const start_date = this.filter.date_range[0] || moment().format();
      const end_date = this.filter.date_range[1] || moment().format();
      const response = await analyticApi.callStatusPercentage({
        workspace_id: this.activeWorkspace._id,
        start_date,
        end_date,
      });
      this.status_incoming_call_chart_options.series = [];
      this.status_incoming_call_chart_options.labels = [];
      this.status_incoming_call_chart_options.colors = [];
      this.status_outgoing_call_chart_options.series = [];
      this.status_outgoing_call_chart_options.labels = [];
      this.status_outgoing_call_chart_options.colors = [];
      this.loading.status_call_chart = false;
      if (!response.error) {
        const result = response.data;
        if (result.incoming) {
          Object.entries(result.incoming).forEach(([key, value]) => {
            if (value > 0) {
              this.status_incoming_call_chart_options.series.push(parseInt(value));
              this.status_incoming_call_chart_options.labels.push(this.formatStatus(key));
              this.status_incoming_call_chart_options.colors.push(this.getRandomColor());
            }
          });
        }
        if (result.outgoing) {
          Object.entries(result.outgoing).forEach(([key, value]) => {
            if (value > 0) {
              this.status_outgoing_call_chart_options.series.push(parseInt(value));
              this.status_outgoing_call_chart_options.labels.push(this.formatStatus(key));
              this.status_outgoing_call_chart_options.colors.push(this.getRandomColor());
            }
          });
        }
      }
      this.loading.status_call_chart = false;
    },
    async getStatusSlaCall() {
      this.loading.sla_call_chart = true;
      const start_date = this.filter.date_range[0] || moment().format();
      const end_date = this.filter.date_range[1] || moment().format();
      const response = await analyticApi.statusSlaCall({
        workspace_id: this.activeWorkspace._id,
        start_date,
        end_date,
      });
      this.sla_call_first_resp_options.series = [];
      this.sla_call_first_resp_options.labels = [];
      this.sla_call_first_resp_options.colors = [];
      this.sla_call_resolution_options.series = [];
      this.sla_call_resolution_options.labels = [];
      this.sla_call_resolution_options.colors = [];
      const colors = {
        ok: '#7db6ef',
        overdue: '#81d2d3',
      };
      if (!response.error) {
        const result = response.data;
        Object.entries(result.first_response).forEach(([key, value]) => {
          if (value > 0) {
            this.sla_call_first_resp_options.series.push(parseInt(value));
            this.sla_call_first_resp_options.labels.push(this.formatStatus(key));
            this.sla_call_first_resp_options.colors.push(colors[key]);
          }
        });
        Object.entries(result.resolution_time).forEach(([key, value]) => {
          if (value > 0) {
            this.sla_call_resolution_options.series.push(parseInt(value));
            this.sla_call_resolution_options.labels.push(this.formatStatus(key));
            this.sla_call_resolution_options.colors.push(colors[key]);
          }
        });
      }
      this.loading.sla_call_chart = false;
    },
    async getStatusSlaTicket() {
      this.loading.sla_ticket_chart = true;
      const start_date = this.filter.date_range[0] || moment().format();
      const end_date = this.filter.date_range[1] || moment().format();
      const response = await analyticApi.statusSlaTicket({
        workspace_id: this.activeWorkspace._id,
        start_date,
        end_date,
      });
      this.sla_ticket_first_resp_options.series = [];
      this.sla_ticket_first_resp_options.labels = [];
      this.sla_ticket_first_resp_options.colors = [];
      this.sla_ticket_resolution_options.series = [];
      this.sla_ticket_resolution_options.labels = [];
      this.sla_ticket_resolution_options.colors = [];
      const colors = {
        ok: '#7db6ef',
        overdue: '#81d2d3',
      };
      if (!response.error) {
        const result = response.data;
        Object.entries(result.first_response).forEach(([key, value]) => {
          if (value > 0) {
            this.sla_ticket_first_resp_options.series.push(parseInt(value));
            this.sla_ticket_first_resp_options.labels.push(this.formatStatus(key));
            this.sla_ticket_first_resp_options.colors.push(colors[key]);
          }
        });
        Object.entries(result.resolution_time).forEach(([key, value]) => {
          if (value > 0) {
            this.sla_ticket_resolution_options.series.push(parseInt(value));
            this.sla_ticket_resolution_options.labels.push(this.formatStatus(key));
            this.sla_ticket_resolution_options.colors.push(colors[key]);
          }
        });
      }
      this.loading.sla_ticket_chart = false;
    },
    checkMMLite() {
      this.showModalReminderMMLite = false;
      this.mm_lite_step = 1;
      if (this.activeWorkspace._id && this.activeWorkspace?.mm_lite?.use_mm_lite !== true) {
        if (this.activeWorkspace?.mm_lite?.already_request) {
          this.mm_lite_step = 2;
        }
        this.showModalReminderMMLite = true;
      }
    },
    async submitMMLite() {
      this.loading.submit_mmlite = true;
      const res = await channelsAPI.submitMMLite(this.activeWorkspace._id);
      this.loading.submit_mmlite = false;
      await popupErrorMessages(res);
      const workspace = this.activeWorkspace;
      workspace.mm_lite = res?.data;
      this.$store.dispatch('workspace/setActiveWorkspace', workspace).then(() => {
        if (workspace.mm_lite?.use_mm_lite === true) {
          this.showModalReminderMMLite = false;
        }
        this.mm_lite_step = 2;
        this.$message({
          type: 'success',
          message: this.$t('mm_lite.success'),
          duration: 30 * 1000,
          showClose: true,
        });
      });
    },
  },
};
</script>
<style>
  /*--------------*/
  span.big-icon {
    font-size: 45px;
    line-height: 100%;
    color: #128c7f;
  }

  .report-wrapper .spacer {
    display: inline-block;
    width: 10px;
    height: 20px;
  }

  .report-wrapper .card-head {
    width: 100%;
    display: block;
    height: 20px;
  }

  .report-wrapper a {
    color: #128c7f;
  }

  .chart-by #apexMixed-1 .apexcharts-legend,
  .chart-by #apexMixed-2 .apexcharts-legend,
  .chart-by #apexMixed-3 .apexcharts-legend {
    bottom: -20px !important;
  }

  .report-header h5 {
    float: left;
    margin-right: 30px;
  }

  .report-header select {
    max-width: 300px;
    float: left;
    margin-top: -10px;
  }
  .fit-tooltip {
    padding: 10px;
    min-width: unset !important;
    width: auto !important;
    max-width: none !important;
    white-space: nowrap;
    text-align: center;
  }

</style>
